import { createSlice, current, type PayloadAction } from '@reduxjs/toolkit';
import { isShallowIdentical } from 'utils/isShallowIdentical';

import { ShareDesignCardStateEnum } from '@inter-ikea-kompis/component-share-design-card';
import { type ZipInCardStateEnum, ZipInModalEnum } from '@inter-ikea-kompis/component-zip-in';
import type { IStore, IZipAvailability } from '@inter-ikea-kompis/types';

type IZip = {
  zipCode?: string;
  zipAvailabilities?: IZipAvailability[];
  zipInCardState?: ZipInCardStateEnum;
  zipInModal?: ZipInModalEnum;
};

type KompisStates = {
  storeId?: string;
  stores?: IStore[];
  shareDesignCardState: ShareDesignCardStateEnum;
  zip: IZip;
};

const initialState: KompisStates = {
  storeId: undefined,
  stores: undefined,
  shareDesignCardState: ShareDesignCardStateEnum.default,
  zip: {
    zipCode: undefined,
    zipAvailabilities: undefined,
    zipInCardState: undefined,
    zipInModal: undefined
  }
};

export const { reducer: kompisStatesReducer, actions: kompisStatesAction } = createSlice({
  name: 'kompisStates',
  initialState,
  reducers: {
    setStoreId: (state, { payload: storeId }: PayloadAction<KompisStates['storeId']>) => {
      if (isShallowIdentical(current(state).storeId, storeId)) {
        return;
      }

      return { ...state, storeId };
    },
    setStores: (state, { payload: stores }: PayloadAction<KompisStates['stores']>) => {
      if (isShallowIdentical(current(state).stores, stores)) {
        return;
      }

      return { ...state, stores };
    },
    setShareDesignCardState: (state, { payload: shareDesignCardState }: PayloadAction<KompisStates['shareDesignCardState']>) => {
      if (isShallowIdentical(current(state).shareDesignCardState, shareDesignCardState)) {
        return;
      }

      return { ...state, shareDesignCardState };
    },
    setZipCode: (state, { payload: zipCode }: PayloadAction<KompisStates['zip']['zipCode']>) => {
      if (isShallowIdentical(current(state).zip.zipCode, zipCode)) {
        return;
      }

      const zip = { ...state.zip, zipCode };
      return { ...state, zip };
    },
    setZipAvailabilities: (state, { payload: zipAvailabilities }: PayloadAction<KompisStates['zip']['zipAvailabilities']>) => {
      if (isShallowIdentical(current(state).zip.zipAvailabilities, zipAvailabilities)) {
        return;
      }

      const zip = { ...state.zip, zipAvailabilities };
      return { ...state, zip };
    },
    setZipInState: (state, { payload: zipInCardState }: PayloadAction<KompisStates['zip']['zipInCardState']>) => {
      if (isShallowIdentical(current(state).zip.zipInCardState, zipInCardState)) {
        return;
      }

      const zip = { ...state.zip, zipInCardState };
      return { ...state, zip };
    },
    setZipInModal: (state, { payload: zipInModal }: PayloadAction<KompisStates['zip']['zipInModal']>) => {
      const zip = { ...state.zip, zipInModal };
      return { ...state, zip };
    }
  }
});
